import gql from "graphql-tag";

export const FacilityFragment = gql`
  fragment FacilityFields on Facility {
    id:_id
    icon
    name
    category
  }
`;